import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7ae9s39dm8: FaireBrandEntity = {
  token: "b_7ae9s39dm8",
  type: "brand",
  name: "Beachy Bubbles Bath Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/a949fd083e0ea5e11816db0f01145e762cc7fa2fa71b32c8b4373db19e2d74c8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2d0e95e1d925ec059fa2c6265214d7c885ad1d964cef54ae5565ec56b1819921.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a949fd083e0ea5e11816db0f01145e762cc7fa2fa71b32c8b4373db19e2d74c8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2d0e95e1d925ec059fa2c6265214d7c885ad1d964cef54ae5565ec56b1819921.jpeg",
  location: "Apollo Beach, FL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 148,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi! I'm Ashley, the owner and creator at Beachy Bubbles Bath Co., based out of the Tampa town of Apollo Beach, FL. I've always had a love for all things bath and body, making concoctions for myself and gifting them to family during the holidays. In early 2021, I decided to take the leap and create my own small business. I've participated in countless local market & events and began selling wholesale to boutiques in early 2022. \n\nAt Beachy Bubbles Bath Co, our brand is all about creating luxurious bath and body products that are vibrant and colorful with a fun, clean look. Our products are crafted in small batches with skin-nourishing ingredients, attractive colors, and gorgeous fragrances. We believe that every person should have the opportunity to indulge in a little luxury and self-care, regardless of their budget. Our mission is to bring the spa to you, and to make you look and feel amazing. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:47.405Z",
    importedBy: "entity-db-cli",
  },
};
